import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { ClientUserRef } from 'dy-frontend-http-repository/lib/modules/ClientUser/refs';
import { TeamFilterInput } from 'dy-frontend-http-repository/lib/modules/Team/inputs';
import { TeamResource } from 'dy-frontend-http-repository/lib/modules/Team/resources';
import repository from 'dy-frontend-http-repository/lib/repository';

import domain from './domain';

// Fetch team list
export const fetchTeams = domain.createEffect<TeamFilterInput, CollectionResource<TeamResource, {}>>({
    name: 'fetchTeams',
    handler: async (filter) => {
        return await repository.team().get(filter);
    },
});

// Create client team connection
export const connectTeamToClient = domain.createEffect<{ userId: ID; teamId: ID }, ClientUserRef>({
    name: 'connectTeamToClient',
    handler: async ({ userId, teamId }) => {
        return await repository.clientUser().connectTeam(userId, teamId);
    },
});
